<swiper [ngClass]="class" [config]="config" [index]="slideIndex" (indexChange)="onIndexChange($event)">
    <ng-content></ng-content>
</swiper>
